import React from 'react'

export const AppFooter = ({AppYear}) => (
    <>
      <footer className="mt-auto">
        <p>Copyright ⓒ {AppYear}</p>
      </footer>
    </>
    ) 